export default class Consumer {
	constructor(sendRequest, device, recvTransport) {

		this._mediaStream = new MediaStream();
		this.video = null;
		this.audio = null;
    this._sendRequest = sendRequest;
    this._device = device;
    this._recvTransport = recvTransport;
	}

	async consume(streamId, producer) {
		console.debug('stream consume');
		try {
			let consumer;

      console.log('stream/addConsumer', streamId)

			const response = await this._sendRequest('stream/addConsumer', {
				streamId,
				rtpCapabilities: this._device.rtpCapabilities,
				producerId: producer.id
			});

			if (response) {
				const { producerId, rtpParameters, kind, consumerId } = response;
				consumer = await this._recvTransport.consume({ id: consumerId, producerId, kind, rtpParameters });
				this._mediaStream.addTrack(consumer.track);
				this[kind] = consumer;
				consumer.resume();
			}

			return consumer;
		} catch (err) {
			console.error('stream consume error', err);
			throw(err);
		}
	}
}
